import React, { useState } from "react";
import { InnerWrapper, OuterWrapper } from "../wrapper/wrapper";
import {
  HeroBackground,
  HeroTitle,
  QuoteText,
  Container,
  CTAButton,
  Details,
  PricingContainer,
  Title,
  TypeTile,
} from "./internship.components";
import BgImage from "../../images/internships/hero-bg2.png";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
} from "@mui/material";
import { useCookies } from "react-cookie";
import ArrowIcon from "../../images/icons/custom-arrow.svg";
import TickIcon from "../../images/icons/circle-tick.svg";
import PaymentPage from "./paymentPage";
import { verifyToken } from "../../services/auth";
import CommonLoginDialog from "../dialog/commonLoginDialog";
import { enrollInInternships } from "../../services/enroll";
import { useAlert } from "react-alert";
import { userInternshipsLink } from "../../common/routes";
import { useNavigate } from "react-router-dom";

import "./internship.css";

function InternshipDetails({ internshipData }) {
  const alert = useAlert();
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const internshipID = window.location.pathname.split("/")[2];

  const enrollFunction = async (orderID) => {
    const enrollData = {
      orderID: orderID,
      internshipID: internshipID,
      userID: cookies.userID,
    };
    // console.log(enrollData);
    await enrollInInternships(cookies, enrollData)
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          alert.success(response.data.message);
          navigate(userInternshipsLink);
        }
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
      <CommonLoginDialog open={open} setOpen={setOpen} />
      <HeroBackground sx={{ backgroundImage: `url(${BgImage})` }}>
        <InnerWrapper sx={{ position: "relative" }}>
          <Stack
            pt={{ xs: "70px", md: "98px" }}
            pl={{ xs: 1, md: 8.5 }}
            pr={{ xs: 1, md: 11 }}
            direction={{ xs: "column", md: "row" }}
          >
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Box
                component="img"
                src={internshipData.imageUrl}
                alt=""
                sx={{
                  width: { xs: 400, md: 505 },
                  height: { xs: 198, md: 250 },
                }}
              />
              <QuoteText
                sx={{
                  width: { md: 700 },
                  display: { xs: "none", md: "block" },
                }}
              >
                {internshipData.quote}
              </QuoteText>
            </Stack>
            <Stack
              direction="column"
              justifyContent="flex-start"
              alignItems="center"
              spacing={{ xs: 4, md: 6 }}
            >
              <HeroTitle
                sx={{
                  fontSize: { xs: "35px", md: "50px" },
                  lineHeight: { md: "68px" },
                }}
              >
                {internshipData.title}
              </HeroTitle>
              <CTAButton component="a" href="#pricing">
                Enroll Now
              </CTAButton>
            </Stack>
          </Stack>
        </InnerWrapper>
      </HeroBackground>
      <OuterWrapper>
        <InnerWrapper>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="center"
            alignItems="center"
            spacing={3.75}
            py={"125px"}
          >
            <Container
              sx={{
                pb: { xs: 2, sm: 0 },
                width: { xs: "95%", sm: "85%", md: "100%" },
              }}
            >
              <Title sx={{ px: { xs: 2.5, md: 5.5 } }}>
                Internship Details
              </Title>
              <Details sx={{ px: { xs: 2.5, md: 5.5 } }}>
                {internshipData.details}
              </Details>
            </Container>
            <Container
              sx={{
                pb: { xs: 2, sm: 0 },
                width: { xs: "95%", sm: "85%", md: "100%" },
              }}
            >
              <Title sx={{ px: { xs: 2.5, md: 5.5 } }}>
                Course Requirements
              </Title>
              <List
                sx={{ px: { xs: 2.5, md: 5.5 } }}
                className="requirementsItem"
              >
                {internshipData.requirements.map((item) => {
                  return (
                    <ListItem sx={{ px: 0, pb: 1.6, pt: 0 }}>
                      <ListItemIcon sx={{ minWidth: 35 }}>
                        <Box component="img" src={ArrowIcon} />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  );
                })}
              </List>
            </Container>
          </Stack>
          <Stack
            id="pricing"
            direction={{ xs: "column", md: "row" }}
            justifyContent="center"
            alignItems="center"
            spacing={6.25}
            pb={"125px"}
          >
            <PricingModel data={internshipData.beginnerPricing} />
            <PricingModel data={internshipData.intermediatePricing} />
            <PricingModel data={internshipData.advancePricing} />
          </Stack>
        </InnerWrapper>
      </OuterWrapper>
    </>
  );

  function PricingModel({ data }) {
    return (
      <PricingContainer
        sx={{
          width: { xs: "85%", sm: "70%", md: 350 },
          height:
            data.type === "intermediate"
              ? { xs: 610, sm: 512, md: 600 }
              : { xs: 610, sm: 512, md: 550 },
        }}
      >
        <TypeTile type={data.type}>{data.type}</TypeTile>
        <List sx={{ px: 1, py: 0 }} className="perksItem">
          {data.perks.map((item) => {
            return (
              <ListItem sx={{ px: 0, pb: 1.4, pt: 0 }}>
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <Box component="img" src={TickIcon} />
                </ListItemIcon>
                <ListItemText primary={item} />
              </ListItem>
            );
          })}
        </List>
        <Stack direction="row" justifyContent="center">
          <PaymentPage
            data={data}
            enrollFunction={enrollFunction}
            verifySession={verifySession}
          />
        </Stack>
      </PricingContainer>
    );
  }

  async function verifySession() {
    var isSessionActive = true;
    await verifyToken(cookies)
      .then((response) => {
        // console.log(response.data)
        if (response.status === 400) {
          setOpen(true);
          isSessionActive = false;
        }
      })
      .catch((error) => console.log(error));
    return isSessionActive;
  }
}

export default InternshipDetails;
